exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-body p + p[data-v-e4731dd0] {\n  margin-top: 1em;\n}\n", ""]);

// exports
